// client/src/pages/Help.js
import React, { useState } from "react";
import { FiChevronDown, FiHelpCircle, FiMail, FiPhone } from "react-icons/fi";

export default function Help() {
  const [open, setOpen] = useState(null);
  const toggle = (i) => setOpen(open === i ? null : i);

  const faqs = [
    {
      q: "What is CollegePal?",
      a: "CollegePal is a campus-focused platform where students can post tasks, recover lost items, create clubs, recruit members, and communicate through real-time chat."
    },
    {
      q: "How do Tasks work?",
      a: "You can post a task describing what help you need. Other students can apply, chat with you, and complete the task. Once completed, it moves to history."
    },
    {
      q: "What is Lost & Found?",
      a: "Lost & Found helps students report lost items or return items they find. Once an item is successfully returned, it is marked as recovered."
    },
    {
      q: "What are Recruit / Clubs?",
      a: "Recruit allows you to create clubs or teams, accept members, manage group chats, and coordinate activities securely within your campus."
    },
    {
      q: "Who can access Group Chats?",
      a: "Group chats are accessible only to the club owner and selected members. Some clubs may allow only announcements from the owner."
    },
    {
      q: "Why am I redirected to login sometimes?",
      a: "For security reasons, some pages require authentication. If your session expires, you may need to log in again."
    },
    {
      q: "How do I contact support?",
      a: "You can email or call us anytime. Most issues are resolved within 24 hours."
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-900 px-6 py-12 text-gray-900 dark:text-white">
      <div className="max-w-4xl mx-auto">

        {/* HEADER */}
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-indigo-600 dark:text-indigo-400">
            Help & Support
          </h1>
          <p className="mt-3 text-gray-600 dark:text-slate-300 text-lg">
            Quick answers and guidance for using CollegePal.
          </p>
        </div>

        {/* FAQ */}
        <div className="space-y-4">
          {faqs.map((f, i) => (
            <div
              key={i}
              className="bg-white dark:bg-slate-800 rounded-xl shadow-md p-5 border border-gray-100 dark:border-slate-700"
            >
              <button
                onClick={() => toggle(i)}
                className="flex justify-between w-full items-center"
              >
                <div className="flex items-center gap-2">
                  <FiHelpCircle className="text-indigo-500" size={20} />
                  <span className="font-semibold">{f.q}</span>
                </div>

                <FiChevronDown
                  size={22}
                  className={`transition-transform ${
                    open === i ? "rotate-180" : ""
                  } text-gray-600 dark:text-gray-300`}
                />
              </button>

              {open === i && (
                <p className="mt-3 text-gray-700 dark:text-slate-300 text-sm leading-relaxed">
                  {f.a}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* CONTACT */}
        <div className="mt-14 text-center">
          <h2 className="text-2xl font-bold text-indigo-600 dark:text-indigo-400 mb-4">
            Contact Support
          </h2>

          <p className="flex justify-center items-center gap-2 text-gray-700 dark:text-slate-300">
            <FiMail className="text-indigo-500" /> collegepal369@gmail.com
          </p>

          <p className="flex justify-center items-center gap-2 mt-2 text-gray-700 dark:text-slate-300">
            <FiPhone className="text-green-500" /> +91 90403 96953
          </p>

          <p className="text-xs text-gray-500 dark:text-slate-400 mt-2">
            Response time: 24 hours
          </p>
        </div>

      </div>
    </div>
  );
}
